
import { apiClient } from "./config";
import { API_FEATURES } from "./apiConfig";
import { AxiosError, AxiosRequestConfig } from "axios";
import { toast } from "@/hooks/use-toast";

// Error response type
interface ApiErrorResponse {
  message: string;
  errors?: Record<string, string[]>;
  status?: number;
}

// Re-export the API client
export default apiClient;

// Generic API request function with type safety
export async function apiRequest<T>(config: AxiosRequestConfig): Promise<T> {
  // Log the base URL in development mode only when debug logs are enabled
  if (API_FEATURES.DEBUG_LOGS) {
    // Debug logs removed
  }

  try {
    const response = await apiClient(config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      const errorMessage =
        (error.response?.data as ApiErrorResponse)?.message || 
        "An unexpected error occurred";

      // Don't show toast for 401 errors (handled by auth interceptor)
      if (error.response?.status !== 401) {
        toast.error(errorMessage);
      }
    }
    throw error;
  }
}
